import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import 'moment/locale/es'
import TagManagerUtils from '../../utils/TagManagerUtils';
import Input from '../common/input/Input';
import i18n from '../../config/I18n';
import { validarStepAction } from '../common/Step/StepsAction';
import ModalErrorGenerico from '../common/Modal/ModalErrorGenerico';
import loaderAction from '../common/loader/LoaderAction';
import Loader from '../common/loader/Loader';
import ButtonBase from '../common/button/ButtonBase';
import Alert from '../common/alert/alert';
import icnVolverInicio from '../assets/svg/icnVolverInicio.svg';
import icnProxPasosEmail from '../assets/svg/icnProxPasosEmail.svg';
import icnProxPasosAprobado from '../assets/svg/icnProxPasosAprobado.svg';
import icnProxPasos48horas from '../assets/svg/icnProxPasos48horas.svg';
import Ejecutivo from '../common/ejecutivo/ejecutivo';
import './Step.css';


class Evaluacion extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.top = React.createRef();
  }

  componentDidMount() {
    const { validaStep, idFlujoSocio, history, token, simulacion, wv } = this.props;

    if (idFlujoSocio === 1 && token) {
      validaStep(3, true);
      // TAG
      const lista = simulacion.resultadoSimulacion.segurosContratados.listaSeguros;
      const segurosSelecionados = [];
      for (let i = 0; i < lista.length; i += 1) {
        segurosSelecionados.push(lista[i].descripcion)
      }

      TagManagerUtils.globalTag({
        'event': 'vpv-privado',
        'page': '/tef/credito-distancia/evaluando/',
        'Seguros': segurosSelecionados.join(' - '),
        'ambiente': wv ? 'app' : 'sitio'
      })
      this.irTop();
    } else {
      history.push({ pathname: '/Page404' });
    }
  }

  cancelarStep = (e) => {
    e.preventDefault();
    // TAG
    TagManagerUtils.globalTag({
      'event': 'eve',
      'eve-acc': '/tef/credito-distancia/resultado',
      'eve-cat': 'Click',
      'eve-lab': 'Volver al inicio'
    })
    window.top.location.href = process.env.URL_PORTAL_PRIVADO;
  }


  // IR A TOP
  irTop = () => {
    this.top.current.focus();
  }


  render() {

    const {
      showLoader,
      modalErrorGenerico,
      wv
    } = this.props;

    return (
      <div className="container-fluid stepContainer evaluacion">
        <div className="top">
          <Input type="text" name="top" reference={this.top} />
        </div>
        <ModalErrorGenerico visible={modalErrorGenerico} wv={wv} />
        <div className="row">
          <div className="col-sm-10  offset-sm-1">
            <Alert
              mensaje={i18n.t('simulacion.alertPrexistencia')}
              tipo="alert-success"
              icons="alertIconSuccess"
            />
          </div>
          <div className="col-sm-3 offset-sm-1 movile-off">
            <Ejecutivo
              mensajesEnrriqusidos={[
                {
                  mensaje: i18n.t('ejecutivos.evaluacion_a'),
                  tipo: 'normal'
                },
                {
                  mensaje: i18n.t('ejecutivos.evaluacion_b'),
                  tipo: 'strong'
                },
                {
                  mensaje: i18n.t('ejecutivos.evaluacion_c'),
                  tipo: 'normal'
                }
              ]}
              tipo="right"
            />
          </div>
          <div className="col-sm-7">
            <div className="card">
              <div className="col-12 ">
                <div className="card-header row">
                  <div className="col-12 txtAlignL pad5">
                    <h3 className="txtBold">{i18n.t('evaluavion.titulo')}</h3>
                  </div>
                </div>
              </div>
              <div className="card-body row">
                <div className="col-12">
                  <p>
                    <img src={icnProxPasosEmail} className="iconsLista" alt="svg" />
                    {i18n.t('evaluavion.nota_a')}
                  </p>
                  <p>
                    <img src={icnProxPasos48horas} className="iconsLista" alt="svg" />
                    {i18n.t('evaluavion.nota_b')}
                  </p>
                  <p>
                    <img src={icnProxPasosAprobado} className="iconsLista" alt="svg" />
                    {i18n.t('evaluavion.nota_c')}
                  </p>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12">
                <div className="row">
                  <div className="col-sm-4" />
                  <div className="col-sm-8 order-sm-first">
                    {!wv && <ButtonBase icons={icnVolverInicio} callClick={this.cancelarStep} css="botonCancelar" etiqueta={i18n.t('ui.volverInicio')} disabled />}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Loader visible={showLoader} />
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    trackId: state.sessionUsuario.trackId,
    stepActual: state.step.stepActual,
    token: state.sessionUsuario.token,
    idFlujoSocio: state.obtenerCampanaUsuario.idFlujo,
    showLoader: state.loader.showLoader,
    modalErrorGenerico: state.modalError.showErrorGenerico,
    simulacion: state.simulacion.detalleSimulacion,
    wv: state.webViuw.estado
  }
}

const mapDispatchToProps = dispatch => {
  return {
    validaStep: (actual, estado) => dispatch(validarStepAction(actual, estado)),
    mostrarLoader: (value) => dispatch(loaderAction(value))
  }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Evaluacion));
